import React from "react";
import { compose, withHandlers, withProps } from "recompose";
import { Row, Col, PopoverHeader, PopoverBody, Button } from "reactstrap";
import { Control, actions } from "react-redux-form";
import { withTranslation, Trans } from "react-i18next";
import shortid from "shortid";
import { get } from "lodash";
import {
  Page,
  onMount,
  withReload,
  withLocalForm,
  FormGroup,
  SubmitButton,
  withPopover,
  getStatus
} from "components/common";
import { Link } from "react-router-dom";
import deepPick from "deepPick";
import {
  withXeroErrors,
  LineItemsView,
  withOptions,
  withDocumentRenderer,
  Attachments,
} from "components";
import { PurchaseOrderDocument } from "components/documents";
import { formatDate } from "../../../../services/util";
import moment from "moment";
import BackButton from "components/refactoring/BackButton";
import { NotificationManager } from "react-notifications";

export const View = ({
  state,
  t,
  LocalForm,
  XeroErrors,
  dispatch,
  xero,
  handleSave,
  Popover,
  history,
  togglePopover,
  DocumentRenderer,
  DownloadDocument,
  EmailDocument,
  PurchaseOrderOptions,
  handleAttachmentsChanged,
}) => {

    const editLink = () => {
        const { PurchaseOrderID } = state;
    
        history.push(`/purchases/purchase_orders/edit/${PurchaseOrderID}`)
      };

    const textColor = "#525F7F"
          
    const SpanColor = ({ children }) => {
        const colorInheritStyle = {
          color: textColor,
          fontSize: "1.2em",
        };
      
        return <span style={colorInheritStyle}>{children}</span>;
      };    


    return (
    <Page
        translate={false}
        title={t(
        state.PurchaseOrderID
            ? "Purchase Order {{ PurchaseOrderNumber }}"
            : "Purchase Order",
        state
        )}
    > 
        <BackButton/>
        <br/>
        <XeroErrors />
        <DocumentRenderer component={PurchaseOrderDocument} />
        <LocalForm>
            <div className="d-flex" style={{paddingBottom:20}}>
                {state.SentToContact && (
                <div className="text-success small">
                    <span className="fa fa-check mr-1" /> <Trans>Sent to contact</Trans>
                </div>
                )}
                <div className="mx-auto" />
                {state.PurchaseOrderID && (
                <EmailDocument className="mr-2" type="PURCHASE_ORDER" item={state} />
                )}
                {state.PurchaseOrderID && <DownloadDocument />}
                {state.PurchaseOrderID && state.Attachments ? (
                  <Attachments
                    xero={xero}
                    hideIncludeOnline
                    onAttachmentsChanged={handleAttachmentsChanged}
                    baseUrl={`purchaseorders/${state.PurchaseOrderID}`}
                    attachments={state.Attachments}
                  />
                ) : null}
                {state.PurchaseOrderID && <PurchaseOrderOptions />}
                {state.Status === "AUTHORISED" && (
                <div>
                    <Button
                    id="mark-as-billed"
                    onClick={togglePopover}
                    className="ml-2 mr-0"
                    size="sm"
                    color="success"
                    >
                    <Trans>Mark as Billed</Trans>
                    </Button>
                    <Popover placement="bottom" target="#mark-as-billed">
                    <PopoverHeader>
                        <Trans>
                        Mark {{ PurchaseOrderNumber: state.PurchaseOrderNumber }} as
                        billed
                        </Trans>
                    </PopoverHeader>
                    <PopoverBody>
                        <FormGroup check label="Copy purchase order to a draft bill">
                        <Control.checkbox model=".copyToBill" />
                        </FormGroup>
                        <div className="text-right mt-3">
                        <SubmitButton
                            size="sm"
                            onClick={() => handleSave({ billed: true })}
                        >
                            Confirm
                        </SubmitButton>
                        </div>
                    </PopoverBody>
                    </Popover>
                </div>
                )}
                <div className="">
                {state.PurchaseOrderID && (state.Status === "DRAFT" || state.Status === "SUBMITTED") && 
                  <button
                      type="button"
                      className="btn-sm btn btn-primary"
                      onClick={editLink}>
                      Edit Purchase Order
                  </button>
                }
                </div>
            </div>
            <div>
                <Row className="mt-3">
                    <Col xs={false} md={3}>
                    <FormGroup label="To" model=".Contact" addControlClass={false}>
                        <Link to={`/contacts/view/${state.Contact.ContactID}`} style={{ color: '#72B566', fontWeight: 'bold', fontSize: '1.3em' }}>
                            {state.Contact.Name || "---"}
                        </Link>
                    </FormGroup>
                    </Col>
                    <Col xs={false} md={3}>
                    <FormGroup label="Status">
                        <SpanColor>{getStatus(state.Status)}</SpanColor>
                    </FormGroup>
                    </Col>
                    <Col xs={false} md={3}>
                    <FormGroup label="Date" model=".Date" className="pt-2 pb-2">
                        <SpanColor>{formatDate(state.Date) || "---"}</SpanColor>
                    </FormGroup>
                    </Col>
                    <Col xs={false} md={3}>
                    <FormGroup label="Delivery Date" model=".DeliveryDate" className="pt-2 pb-2">
                        <SpanColor>{formatDate(state.DeliveryDate) || "---"}</SpanColor>
                    </FormGroup>
                    </Col>
                    <Col xs={false} md={3}>
                    <FormGroup label="Order number" model=".PurchaseOrderNumber" className="pt-2 pb-2">
                        <SpanColor>{state.PurchaseOrderNumber || "---"}</SpanColor>
                    </FormGroup>
                    </Col>
                    <Col xs={false} md={3}>
                    <FormGroup label="Reference" model=".Reference" className="pt-2 pb-2">
                        <SpanColor>{state.Reference || "---"}</SpanColor>
                    </FormGroup>
                    </Col>
                </Row>
                <hr />
                <LineItemsView includeDiscount item={state} dispatch={dispatch} xero={xero} hideAddLines={true} hideAccountAndTax={false} />
                <hr />
                <Row>
                    <Col xs={6}>
                        <FormGroup label="Delivery Address" model=".DeliveryAddress" className="pt-2 pb-2">
                            <span style={{ color: textColor, whiteSpace: 'pre-line', fontSize: "1.2em" }}>{state.DeliveryAddress || '---'}</span>
                        </FormGroup>
                        <FormGroup label="Delivery Instructions" model=".DeliveryInstructions" className="pt-2 pb-2">
                            <SpanColor>{state.DeliveryInstructions || '---'}</SpanColor>
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup label="Attention" model=".AttentionTo" className="pt-2 pb-2">
                            <SpanColor>{state.AttentionTo || '---'}</SpanColor>
                        </FormGroup>
                        <FormGroup label="Telephone" model=".Telephone" className="pt-2 pb-2">
                            <SpanColor>{state.Telephone || '---'}</SpanColor>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </LocalForm>
    </Page>
    )};

const initialState = {
  Type: "PURCHASEORDER",
  LineItems: [
    {
      _id: shortid(),
    },
  ],
  Date: formatDate(moment()),
  Status: "DRAFT",
};

export const enhance = compose(
  withTranslation(),
  withReload(),
  withXeroErrors(),
  onMount(
    ({
        xero,
        location,
        match: {
          params: { id },
        },
      }) =>
      () =>
        Promise.props({
          state:
            id === "new"
              ? get(location, "state.copy") || initialState
              : xero
                  .get(`purchaseorders/${id}`)
                  .get("data")
                  .then(({ LineItems, ...data }) => ({
                    ...data,
                    LineItems: LineItems.map((i) => ({
                      ...i,
                      _id: shortid(),
                    })),
                  })),
        })
  ),
  withLocalForm({
    initialState: (props) => props.state,
  }),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
      () => {
        xero
          .get(`purchaseorders/${match.params.id}/attachments`)
          .get("data")
          .tap((d) => dispatch(actions.change("local.Attachments", d)));
      },
    handleSave:
      ({ state, xero, reload, history, match, setXeroErrors, t, store }) =>
      ({ draft, approve, submit, addAnother, billed } = {}) => {
        const { valid } = store.getState().forms.$form;
        if (!valid) return;
        const idKey = "PurchaseOrderID";
        const numberKey = "PurchaseOrderNumber";
        const url = "purchaseorders";
        const entity = "Purchase Order";
        const allowedProps = [
          "Contact",
          "LineItems",
          "Date",
          "DeliveryDate",
          "LineAmountTypes",
          "PurchaseOrderNumber",
          "PurchaseOrderID",
          "Reference",
          "CurrencyCode",
          "Status",
          "DeliveryAddress",
          "AttentionTo",
          "Telephone",
          "DeliveryInstructions",
          "Contact.ContactID",
        ];

        let Status = state.Status;
        if (draft) Status = "DRAFT";
        if (approve) Status = "AUTHORISED";
        if (submit) Status = "SUBMITTED";
        if (billed) Status = "BILLED";
        setXeroErrors(null);

        const id = state[idKey];

        const allowedItem = deepPick(state, allowedProps);

        allowedItem.LineItems = allowedItem.LineItems.map(i => ({
          ...i,
          DiscountAmount: undefined,
          TaxAmount: undefined,
          LineAmount: undefined
        }))

        const p = id
          ? xero.put(`${url}/${id}`, {
              ...allowedItem,
              Status,
            })
          : xero.post(url, {
              ...allowedItem,
              [numberKey]: undefined,
              Status,
            });

        p.then(({ data }) => {
          NotificationManager.success(t(`${entity} saved successfully`));

          if (state.copyToBill) {
            history.push(`/purchases/bills/edit/new`, {
              copy: {
                  ...state,
                  Status: "DRAFT",
                  InvoiceNumber: state.Reference,
                  Type: "ACCPAY",
              },
          });
          } else if (addAnother) {
            history.push(match.path.replace(":id", "new"));
            reload();
          } else {
            history.replace(`/purchases/purchase_orders/view/${data[idKey]}`);
            reload();
          }
        }, setXeroErrors);
      },
  }),
  withPopover(),
  withProps(({ state: item }) => ({ item })),
  withOptions(),
  withDocumentRenderer({
    onDownload:
      ({ item }) =>
      (getDocument) =>
        getDocument({ item }, `purchaseorder_${item.PurchaseOrderNumber}.pdf`),
  })
);

export default enhance(View);
